export const theme = {
    colors: {
        blue: "#5C85FF",
        green: "#75CAAA",
        black: '#2a2b2b'
    }
}